import React from 'react';
import axios from 'axios';

import { formatNull } from '../../Utils/GlobalUtils';
import { useTimeModal } from '../TimeModal/TimeModalContext';

import EditArbitrationCourt from './Components/EditArbitrationCourt';
import DeleteAC from './Components/DeleteAC';

import Loading from '../Loading';
import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

import IconContainer from '../IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as CommentRedoIcon } from '../../icons/comment-redo.svg';
import ButtonWithConfirmation from '../ButtonWithConfirmation';

const ArbitrationCourtsList = () => {
  const { openTimeModal } = useTimeModal;

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-all-arbitration-courts`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload]);

  const handleChangeIsActive = (id) => {
      const token = localStorage.getItem('token');

      setLoading(true);
  
      axios.put(`/api/change-is-active-arbitration-court/${id}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          }
      })
      .then(() => {
          setReload(true);
      })
      .catch((error) => {
          openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
      });
  };

  const [isModal, setIsModal] = React.useState(false);
  const [isDeleteModal, setIsDeleteModal] = React.useState(false);
  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('add');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsModal(true);
  };


  return (
    <>
        {isModal && <EditArbitrationCourt closeModal={() => setIsModal(false)} id={currentId} action={currentAction} onReloadTable={() => setReload(true)} />}
        {isDeleteModal && <DeleteAC closeModal={() => setIsDeleteModal(false)} handleChangeIsActive={() => handleChangeIsActive(currentId)} />}

        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <div>
                <button 
                  type='button' 
                  className='secondaryButton' 
                  onClick={() => openSuperModal('', 'add')} 
                >
                    <IconContainer
                        Icon={PlusIcon}
                        isClickable={false}
                        size='14'
                        color='white'
                    />
                    Добавить Арбитражный суд
                </button>
                </div>
                <a className='lastUpdateWrapper'>
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{ gridTemplateColumns: '50fr 40fr 10fr' }}>
                <div>Название</div>
                <div>Код для автоподстановки</div>
                <div></div>
            </div>
            </div>
            {(cases.length==0 && loading) ? <LoadingLines />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
            : cases.map((caseItem) => (
                <div 
                  className='tableRow nonActive' 
                  style={{ gridTemplateColumns: '50fr 40fr 10fr' }}
                  key={caseItem.id}
                >
                  <div>
                    <p style={!caseItem.is_active ? { opacity: '0.7' } : undefined}>{formatNull(caseItem.name)} {!caseItem.is_active && '[Не учитывается]'}</p>
                  </div>
                  <div>
                    <p style={!caseItem.is_active ? { opacity: '0.7' } : undefined}>{formatNull(caseItem.court_code)}</p>
                  </div>
                  <div>
                    <span
                      className='horizontalContainer'
                      style={{justifyContent: 'end'}}
                    >
                      {caseItem.is_active ? 
                      <>
                        <IconContainer 
                            Icon={PenIcon} 
                            onClick={() => openSuperModal(caseItem.id, 'change')} 
                            size = '16' 
                            color = 'blue' 
                        />
                        <ButtonWithConfirmation 
                            entryFunc={() => {setIsDeleteModal(true); setCurrentId(caseItem.id)}} 
                            Icon={TrashIcon} 
                            IconSize={16}
                            labelText='' 
                            buttonName='Не учитывать' 
                            color='red' 
                        />
                      </>
                      : 
                        <ButtonWithConfirmation 
                            entryFunc={() => {handleChangeIsActive(caseItem.id)}} 
                            Icon={CommentRedoIcon} 
                            IconSize={16}
                            labelText='' 
                            buttonName='Снова учитывать' 
                            color='blue' 
                        />
                      }
                    </span>
                  </div>
                </div>
            ))}
        </div>
    </>
  )
}

export default ArbitrationCourtsList;